import { createContext, useContext } from 'react';
import type { Media } from '@sazerac/design-tokens';

/**
 * Blocks store a `mediaId`; the page payload carries the resolved assets. This context
 * hands blocks the lookup so no block needs its own request.
 */
export const BlockMediaContext = createContext<Record<string, Media>>({});

export function useBlockMedia(mediaId?: string | null): Media | undefined {
  const media = useContext(BlockMediaContext);
  return mediaId ? media[mediaId] : undefined;
}
